import React from 'react';

import { useAppDispatch, useAppSelector } from 'segments/hooks';

import { changeProductsActiveModal, ProductInfo, selectProductsActiveModal } from 'features/products';

import EditProductModal from './components/EditProductModal';

type Props = {
  selectedProduct?: ProductInfo;
};

export const ProductsModals = ({ selectedProduct }: Props) => {
  const activeModal = useAppSelector(selectProductsActiveModal);
  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(changeProductsActiveModal(null));

  return (
    <EditProductModal
      key={`edit-product-modal${ selectedProduct?.id}`}
      isModalOpen={activeModal === 'edit-product-modal'}
      handleCancel={closeModal}
      data={selectedProduct}
    />
  );
};
